var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H18C18.5523 0 19 0.447715 19 1C19 1.55228 18.5523 2 18 2H1C0.447715 2 0 1.55228 0 1ZM4 5C4 4.44772 4.44772 4 5 4H18C18.5523 4 19 4.44772 19 5C19 5.55228 18.5523 6 18 6H5C4.44772 6 4 5.55228 4 5ZM0 9C0 8.44772 0.447715 8 1 8H18C18.5523 8 19 8.44772 19 9C19 9.55229 18.5523 10 18 10H1C0.447715 10 0 9.55229 0 9ZM4 13C4 12.4477 4.44772 12 5 12H18C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14H5C4.44772 14 4 13.5523 4 13Z",
    fill: "#767C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/navigationIcon.17f0a4d1fd9081a72c26be81e16d4313.svg";
export { ForwardRef as ReactComponent };